import { render } from "./PosRightContent.vue?vue&type=template&id=83586e22&scoped=true&ts=true"
import script from "./PosRightContent.vue?vue&type=script&lang=ts"
export * from "./PosRightContent.vue?vue&type=script&lang=ts"

import "./PosRightContent.vue?vue&type=style&index=0&id=83586e22&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83586e22"]])

export default __exports__